import { IRecommendedShipmentFragment } from 'apps/fleet-planner/components/shipment/ShipmentCard/graphql/RecommendedShipmentFragment'
import { Recommendation } from 'apps/fleet-planner/types'

export const getRecommendedShipment = (
  recommendation: Recommendation
): IRecommendedShipmentFragment => {
  const {
    deliveryCity,
    deliveryStateCode,
    deliveryTimes,
    deliveryTimezone,
    distance,
    equipmentName,
    equipmentParentId,
    pickupCity,
    pickupStateCode,
    pickupTimes,
    pickupTimezone,
    rate,
    shipmentId,
    unviewed,
    weight,
  } = recommendation || {}
  return {
    deliveryCity: deliveryCity || '',
    deliveryStateCode: deliveryStateCode || '',
    deliveryTimes: deliveryTimes || [],
    deliveryTimezone: deliveryTimezone || 'America/New_York',
    distance: distance || 0,
    equipmentName: equipmentName || '',
    equipmentParentId: `${equipmentParentId}` || '',
    pickupCity: pickupCity || '',
    pickupStateCode: pickupStateCode || '',
    pickupTimes: pickupTimes || [],
    pickupTimezone: pickupTimezone || 'America/New_York',
    rate: Number(rate) || 0,
    shipmentId: `${shipmentId}` || '',
    unviewed: unviewed || true,
    weight: weight || 0,
  }
}
